import { render } from "./HorseEditMainStudbooks.vue?vue&type=template&id=481d1471"
import script from "./HorseEditMainStudbooks.vue?vue&type=script&lang=js"
export * from "./HorseEditMainStudbooks.vue?vue&type=script&lang=js"

import "./HorseEditMainStudbooks.vue?vue&type=style&index=0&id=481d1471&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__